// @flow
import { decorate, observable, action } from 'mobx';
import GWUApi from '../../api';
import type { Resource } from 'gwu';

class ResourceStore {
  feed: Array<Resource> = [];

  async getFeed() {
    if (this.feed.length === 0) {
      const { data } = await GWUApi.getFeed();
      this.feed = data;
    }
  }
}

decorate(ResourceStore, {
  feed: observable,
  getFeed: action
});

export default new ResourceStore();



// WEBPACK FOOTER //
// ./src/modules/resource/ResourceStore.js